export const CART_ELEMENT_ID = 'header-cart'
